import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { TextField, Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
// import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

export default function WfModalReject (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const outerFormRef = useRef(document.getElementById(props.formId))
  const innerFormRef = useRef(null)

  useEffect(() => {
    document.querySelectorAll('button.open-wf-reject-modal').forEach((el) => {
      $(el).on('click', () => setModalOpen(true))
    })
  }, [])

  function onSubmitButtonClick () {
    if (outerFormRef.current) {
      Array.from(innerFormRef.current.elements).forEach((element) => {
        outerFormRef.current.insertBefore(element.cloneNode(true), null)
      })
      outerFormRef.current.submit()
    }
  }

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <form action="" method="post" ref={innerFormRef} encType="multipart/form-data">
          <h2>否認確認</h2>
          <hr />
          <p>この申請を否認し、<b>申請者のアドレスに以下の文面でメールを送信します。</b></p>
          <TextField
            variant="standard"
            id='reject_comment'
            name="reject_comment"
            type='text'
            defaultValue={props.defaultMessageLines.join('\n')}
            label='メール文面'
            placeholder=""
            multiline={true}
            minRows={7}
            maxRows={7}
            className='w-100 mb-2'
            inputProps={{
              maxLength: 1000
            }}
          >
          </TextField>
        </form>
        <div className="row">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => setModalOpen(false)}>キャンセル</button>
          </div>
          <div className="col-6 text-right">
            <button type='button' className='btn btn-danger' onClick={onSubmitButtonClick}>
              否認
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

WfModalReject.propTypes = {
  formId: PropTypes.string,
  defaultMessageLines: PropTypes.arrayOf(PropTypes.string)
}

$('.wf-modal-reject').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WfModalReject {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
